export default {
  page: {
    mockup: {
      enabled: false,
    },
    product: {
      enableVoucherSlider: false,
      enableSaleTargetBanner: true,
      enableFeaturedProduct: false,
      enableOnboarding: false,
      enableTireDot: false,
      enableDirectInquiry: false,
      enableOEAttributeValueBox: true,
      enableProductBundle: true,
      showReservedStockCount: true,
    },
    dashboard: {
      enableVoucherSlider: false,
      dashboardSetting: 'default' as 'default' | 'customizable_v1' | 'draggable',
    },
    cart: {
      enableVoucherSelector: false,
    },
    misc: {
      enableCustomPage: true,
      useSkeletonLoader: true,
      enableGuidedTour: false,
    },
    admin: {
      analytics: {
        enabled: false,
      },
      userManagement: {
        enabled: true,
      },
      dashboardSettings: {
        enabled: false,
      },
      emailSettings: {
        enabled: false,
      },
      importExportSettings: {
        enabled: false,
      },
    },
  },
  component: {
    header: {
      enableLogoThemeVariant: true,
    },
    voucher: {
      enabled: false,
      enableProductFilter: false,
    },
    checkout: {
      enableCheckoutStepsInProduct: true,
      enableDeliveryOption: false,
      enableShippingAddressOption: true,
      enableStockCheck: false,
      enableOrderPrecheck: false,
    },
    productSearch: {
      enableSuggestion: true,
    },
  },
  auth: {
    useCookieTokenStorage: false,
    useLegacyTokenStorage: true,
    enableRefreshToken: false,
  },
};
